import {Pipe, PipeTransform} from '@angular/core';
import get from 'lodash/get';

type LabelGeneratorFn = (...args: any[]) => string;
type ExtrasGeneratorFn = (...args: any[]) => string[];
type LabelFieldInput = string | LabelGeneratorFn;
type SearchExtrasFieldInput = string | ExtrasGeneratorFn;
@Pipe({
  name: 'toSelectDropdownOptions',
  pure: true
})
export class ToSelectSearchDropdownOptions implements PipeTransform {
  public getLabel = (item: any, labelField: LabelFieldInput): string => {
    switch (true) {
      case item == null:
        return item;
      case typeof labelField === 'string':
        return get(item, labelField as string);
      case labelField instanceof Function:
        const itemLabel = labelField as (item: any) => string;
        return itemLabel(item);
    }
    return item;
  };

  public getValue = (item: any, valueField: LabelFieldInput): any => {
    switch (true) {
      case item == null:
        return null;
      case valueField === null:
        return item;
      case typeof valueField === 'string':
        return get(item, valueField as string);
      case valueField instanceof Function:
        const itemValue = valueField as (item: any) => string;
        return itemValue(item);
    }
    return item;
  };
  public getExtras = (item: any, extrasField: SearchExtrasFieldInput): string[] => {
    switch (true) {
      case item == null:
        return [];
      case typeof extrasField === 'string':
        return [get(item, extrasField as string)].flat();
      case extrasField instanceof Function:
        const itemExtras = extrasField as (item: any) => string[];
        return itemExtras(item);
    }
    return null;
  };

  private flatternOptions(items: {level: number; children: any[]}[], level = 0, parent: any = null) {
    return items.flatMap(item => [[item, level, parent], ...('children' in item ? this.flatternOptions(item.children, level + 1, item) : [])]);
  }

  transform(
    options: any[],
    valueField: string = 'code',
    labelFieldInput: LabelFieldInput = 'name',
    createLabelFromValue = false,
    extrasField: SearchExtrasFieldInput = null
  ): {label: string; value: any}[] {
    if(!options) {
      return [];
    }
    const flatternedItems = this.flatternOptions(options);

    return flatternedItems
          .map(([option, level, parent]) => {
            const value = this.getValue(option, valueField);
            const label = this.getLabel(createLabelFromValue ? value : option, labelFieldInput);
            const extras = this.getExtras(extrasField ? value : option, extrasField);
            return {
              label,
              value,
              option,
              parent,
              level,
              extras
            };
          })
          .map((option, optionIndex, list) => {
            option.parent = option.parent ? list.find(o => o.option === option.parent) : null;
            return option;
          });
  }
}
